import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  LinearProgress,
  Menu,
  MenuItem,
  TextField,
  Typography,
  makeStyles,
  FormControl,
  FormHelperText,
  useMediaQuery,
  FormLabel,
  useTheme,
} from "@material-ui/core";
import InputMask from "react-input-mask";
import React, { useMemo, useState } from "react";
import { generatePath, useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { Pagination } from "@material-ui/lab";
import { toast } from "react-toastify";
import { delUser, loadReenviarToken } from "actions/actions";
import LoadingScreen from "components/reusable/LoadingScreen/LoadingScreen";
import GradientButton from "components/reusable/GradientButton/GradientButton";
import { useIndexAdmQuery, useStoreAdmMutation } from "services/api";
import CustomTable from "components/reusable/CustomTable/CustomTable";
import useDebounce from "hooks/useDebounce";
import CustomBreadcrumbs from "components/reusable/CustomBreadcrumbs/CustomBreadcrumbs";
import SearchBar from "components/reusable/SearchBar/SearchBar";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  dialogHeader: {
    background: theme.gradient.main,
    color: "white",
  },
  button: {
    width: "70px",
  },
}));

const columns = [
  { headerText: "Nome", key: "nome" },
  { headerText: "Documento", key: "documento" },
  { headerText: "E-mail", key: "email" },
  { headerText: "Criado por", key: "created_by_email" },
  {
    headerText: "Criado em",
    key: "created_at",
    CustomValue: (data) => {
      const date = new Date(data);
      const option = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      };
      const [dia] = date.toLocaleDateString("pt-br", option).split(" ");
      return <Typography align="center">{dia}</Typography>;
    },
  },
  { headerText: "", key: "menu" },
];

const ListaDeAdministradores = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [storeAdm, storeAdmStatus] = useStoreAdmMutation();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const storeAdmError = useMemo(
    () => (storeAdmStatus.error ? storeAdmStatus.error.data.errors : null),
    [storeAdmStatus]
  );
  const [loadingStore, setLoadingStore] = useState(false);

  const [filters, setFilters] = useState({
    like: "",
  });
  const [newAdm, setNewAdm] = useState({
    nome: "",
    email: "",
    documento: "",
  });

  const debouncedLike = useDebounce(filters.like, 800);

  const {
    data: admList,
    refetch,
    isLoading,
    isError,
    isUninitialized,
  } = useIndexAdmQuery(
    {
      page,
      debouncedLike,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const handleStoreAdm = async () => {
    setLoadingStore(true);
    try {
      await storeAdm(newAdm).unwrap();
      toast.success("Administrador criado com sucesso!");
      refetch();
      setOpen(false);
      setNewAdm({
        nome: "",
        email: "",
        documento: "",
      });
    } catch (e) {
      toast.error("Erro ao criar Administrador!");
    }
    setLoadingStore(false);
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  const Editar = ({ row }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleReenvioToken = async () => {
      await dispatch(loadReenviarToken(row.id));
      setAnchorEl(null);
    };

    const handleExcluir = async () => {
      await dispatch(delUser(row.id));
      setAnchorEl(null);
      refetch();
      setOpenDeleteDialog(false);
    };

    const handleGerenciar = () => {
      const path = generatePath(
        "/dashboard/lista-de-administradores/:id/permissoes",
        {
          id: row.id,
        }
      );
      history.push(path);
      setAnchorEl(null);
    };

    return (
      <Box>
        <Button
          style={{ height: "15px", width: "10px" }}
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          ...
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={() => setOpenDeleteDialog(true)}>Excluir</MenuItem>
          <MenuItem onClick={() => handleReenvioToken(row)}>
            Reenviar Token de Confirmação
          </MenuItem>
          <MenuItem onClick={() => handleGerenciar(row)}>
            Gerenciar Permissões
          </MenuItem>
        </Menu>

        <Dialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Deseja realmente excluir este Administrador?
          </DialogTitle>
          <Box
            width="50%"
            alignSelf="end"
            display="flex"
            justifyContent="space-around"
            padding="12px 24px"
          >
            <Box margin="6px 0">
              <GradientButton buttonText={"Deletar"} onClick={handleExcluir} />
            </Box>
            <Box>
              <Button
                style={{ borderRadius: "37px", margin: "6px 0" }}
                variant="outlined"
                onClick={() => {
                  setOpenDeleteDialog(false);
                }}
              >
                Cancelar
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
    );
  };

  return (
    <Box className={classes.root}>
      <CustomBreadcrumbs path1="Administradores" to1="#" />
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection={matches ? "column" : null}
      >
        <Box marginBottom={2}>
          <Typography variant="h4" style={{ color: theme.palette.background.default }}>
            ADMINISTRADORES
          </Typography>
        </Box>
        <Button
          variant="outlined"
          style={{ marginTop: "8px", marginBottom: "12px" }}
          onClick={() => {
            setOpen(true);
          }}
        >
          Criar Administrador
        </Button>
      </Box>
      <Box marginBottom="16px">
        <SearchBar
          fullWidth
          placeholder="Pesquisar por nome, documento, e-mail..."
          value={filters.like}
          onChange={(e) =>
            setFilters({
              ...filters,
              like: e.target.value,
            })
          }
        />
      </Box>

      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <Box display="flex" flexDirection="column" width="400px">
          <LoadingScreen isLoading={loadingStore} />
          <DialogTitle className={classes.dialogHeader}>
            Criar Administrador
          </DialogTitle>
          <Box margin="20px">
            <FormControl fullWidth>
              <Box marginTop={2}>
                <FormLabel component="label">Nome</FormLabel>
                <TextField
                  value={newAdm.nome}
                  onChange={(event) =>
                    setNewAdm({
                      ...newAdm,
                      nome: event.target.value,
                    })
                  }
                  required
                  style={{
                    marginBottom: "6px",
                    width: "100%",
                  }}
                />
                {storeAdmError ? (
                  <FormHelperText
                    style={{
                      marginBottom: "6px",
                      width: "60%",
                      color: "red",
                    }}
                  >
                    {storeAdmError.nome ? storeAdmError.nome[0] : null}
                  </FormHelperText>
                ) : null}
              </Box>
              <Box marginTop={2}>
                <FormLabel component="label">Documento</FormLabel>
                <InputMask
                  mask={"999.999.999-99"}
                  value={newAdm.documento}
                  onChange={(event) =>
                    setNewAdm({
                      ...newAdm,
                      documento: event.target.value,
                    })
                  }
                >
                  {() => (
                    <TextField
                      fullWidth
                      required
                      style={{
                        marginBottom: "6px",
                        width: "100%",
                      }}
                    />
                  )}
                </InputMask>
                {storeAdmError ? (
                  <FormHelperText
                    style={{
                      marginBottom: "6px",
                      width: "60%",
                      color: "red",
                    }}
                  >
                    {storeAdmError.documento
                      ? storeAdmError.documento[0]
                      : null}
                  </FormHelperText>
                ) : null}
              </Box>
              <Box marginTop={2}>
                <FormLabel component="label">Email</FormLabel>
                <TextField
                  value={newAdm.email}
                  onChange={(event) =>
                    setNewAdm({
                      ...newAdm,
                      email: event.target.value,
                    })
                  }
                  required
                  style={{
                    marginBottom: "6px",
                    width: "100%",
                  }}
                />
                {storeAdmError ? (
                  <FormHelperText
                    style={{
                      marginBottom: "6px",
                      width: "60%",
                      color: "red",
                    }}
                  >
                    {storeAdmError.email ? storeAdmError.email[0] : null}
                  </FormHelperText>
                ) : null}
              </Box>
            </FormControl>
          </Box>
          <Box alignSelf="end" display="flex" padding="12px 24px">
            <Box margin="6px 0" padding="0 12px">
              <GradientButton buttonText={"Criar"} onClick={handleStoreAdm} />
            </Box>
            <Box>
              <Button
                style={{ borderRadius: "37px", margin: "6px 0" }}
                variant="outlined"
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancelar
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>
      <>
        {!isLoading && !isError && !isUninitialized ? (
          <>
            <CustomTable
              columns={columns}
              data={admList.data}
              Editar={Editar}
            />
            <Box alignSelf="flex-end" marginTop="8px">
              <Pagination
                variant="outlined"
                color="secondary"
                size="large"
                count={admList.last_page}
                onChange={handleChangePage}
                page={page}
              />
            </Box>
          </>
        ) : (
          <LinearProgress />
        )}
      </>
    </Box>
  );
};

export default ListaDeAdministradores;
